/**
 * Drag-state machine for the editor canvas. The CityScene fires pointer
 * events; the editor's pointer handlers transition this store and request
 * ghost overlays from the renderer. Step 3 wires up `moving`, step 4/5 wire
 * up `placing-from-inventory` / `placing-from-palette`.
 */
import { writable, type Writable } from 'svelte/store'

export type DragState =
  | { kind: 'idle' }
  | {
      kind: 'moving'
      buildingId: number
      /** Cursor offset from the building's top-left at pointerdown, in grid cells. */
      offset: { dx: number; dy: number }
      /** Original position so we can build a clean `move` command on drop. */
      from: { x: number; y: number }
      /** Current ghost grid position. */
      ghost: { x: number; y: number }
    }
  | {
      kind: 'placing-from-inventory'
      inventoryId: number
      cityentityId: string
      width: number
      height: number
      level?: number
      ghost: { x: number; y: number } | null
    }
  | {
      kind: 'placing-from-palette'
      cityentityId: string
      width: number
      height: number
      level?: number
      ghost: { x: number; y: number } | null
    }

export const dragState: Writable<DragState> = writable({ kind: 'idle' })

export function clearDrag(): void {
  dragState.set({ kind: 'idle' })
}
